import { render, staticRenderFns } from "./TrademarkTransactionReportDetail.vue?vue&type=template&id=ff310434&"
import script from "./TrademarkTransactionReportDetail.vue?vue&type=script&lang=js&"
export * from "./TrademarkTransactionReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkTransactionReportDetail.vue?vue&type=style&index=0&id=ff310434&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports